import { query } from '@confluence/query-preloader-tools';

import { PersonalSpaceDetailQuery } from './PersonalSpaceDetailQuery.graphql';

export const preloadPersonalSpaceDetail = () => {
	return query({
		query: PersonalSpaceDetailQuery,
	});
};
